import { createFileRoute, useRouter } from "@tanstack/react-router";

import { NewStoryPage } from "@/features/content/pages";

export const Route = createFileRoute("/_app/growth/stories/new")({
  component: NewStory,
});

function NewStory() {
  const router = useRouter();
  return (
    <NewStoryPage
      onCreated={(storyId) =>
        void router.navigate({ to: "/growth/stories/$storyId", params: { storyId }, replace: true })
      }
      onCancel={() => void router.navigate({ to: "/growth/stories" })}
    />
  );
}
